import flatpickr from 'flatpickr';
import { Russian } from 'flatpickr/dist/l10n/ru';
import 'flatpickr/dist/themes/dark.css';

const initDateTimePicker = () => {
  let fromMinTime,
      fromMaxTime,
      toMinTime,
      toMaxTime;

  const dateOn = flatpickr('.js-datetimepicker', {
    dateFormat: "d M Y",
    defaultDate: [new Date()],
    minDate: "today",
    enableTime: false,
    locale: Russian,

    onChange: function (selectedDates, dateStr, instance) {
      const day = new Date(selectedDates).getDay();

      let weekend = day === 0 || day === 6;

      if(weekend) {
        timefrom.config.minTime = fromMinTime = "10:00"
        timefrom.config.maxTime = fromMaxTime = "15:00"

        timeto.config.minTime = toMinTime = "11:00"
        timeto.config.maxTime = toMaxTime = "16:00"
      }
      else {
        timefrom.config.minTime = fromMinTime = "09:00"
        timefrom.config.maxTime = fromMaxTime = "19:00"

        timeto.config.minTime = toMinTime = "10:00"
        timeto.config.maxTime = toMaxTime = "20:00"
      }

      timefrom.input.value = fromMinTime;
      timeto.input.value = toMinTime;
    },
  });

  var timefrom = flatpickr('.js-datetimepicker-t-from', {
    time_24hr: true,
    noCalendar: true,
    enableTime: true,
    minTime: "09:00",
    defaultDate: ['09:00'],
    defaultHour: 9,
    defaultMinute: 0,
    onChange: function (selectedDates, dateStr, instance) {
      const valueHr = instance.input.value.split(':')[0];
      timeto.config.minTime = toMinTime = (+valueHr + 1) + ":00"
      timeto.input.value = toMinTime;
    }
  });


  var timeto = flatpickr('.js-datetimepicker-t-to', {
    time_24hr: true,
    noCalendar: true,
    enableTime: true,
    minTime: toMinTime,
    defaultDate: ['10:00'],
    defaultHour: 10,
    defaultMinute: 0,
  });
}

export default initDateTimePicker;
